export default "__VITE_ASSET__DQepw5q9__"